import { render, staticRenderFns } from "./MaterialRequest.vue?vue&type=template&id=19b84f4e&scoped=true"
import script from "./MaterialRequest.vue?vue&type=script&lang=js"
export * from "./MaterialRequest.vue?vue&type=script&lang=js"
import style0 from "./MaterialRequest.vue?vue&type=style&index=0&id=19b84f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b84f4e",
  null
  
)

export default component.exports